import { createSlice } from '@reduxjs/toolkit';

const user = createSlice({
    name: 'info',
    initialState: {
        userdata: '',
        seltypes: '',
        category_1s: '',
        listset1: [],
        listset2: [],
        listset3: [],
        listset1_2: [],
        listset2_2: [],
        listset3_2: [],
        listset1_3: [],
        listset2_3: [],
        listset3_3: [],
        companylogourl: '',
        miniViewIds: [],
        gptCounts: {
            dates: '', counts: 0
        },
    },

    reducers: {
        useropen(state, action) {
            state.userdata = action.payload.userdata;
        },
        seltypeorcategory(state, action) {
            state.seltypes = action.payload.seltypes;
            state.category_1s = action.payload.category_1s;
        },
        listsetting1(state, action) {
            state.listset1 = action.payload.listset1;
        },
        listsetting2(state, action) {
            state.listset2 = action.payload.listset2;
        },
        listsetting3(state, action) {
            state.listset3 = action.payload.listset3;
        },
        listsetting1_2(state, action) {
            state.listset1_2 = action.payload.listset1_2;
        },
        listsetting2_2(state, action) {
            state.listset2_2 = action.payload.listset2_2;
        },
        listsetting3_2(state, action) {
            state.listset3_2 = action.payload.listset3_2;
        },
        listsetting1_3(state, action) {
            state.listset1_3 = action.payload.listset1_3;
        },
        listsetting2_3(state, action) {
            state.listset2_3 = action.payload.listset2_3;
        },
        listsetting3_3(state, action) {
            state.listset3_3 = action.payload.listset3_3;
        },
        companylogourlset(state, action) {
            state.companylogourl = action.payload.companylogourl;
        },
        gptcountset(state, action) {
            state.gptCounts = action.payload.gptCounts;
        },
        setMiniViewIds(state, action) {
            if (action.payload === 0) {
                state.miniViewIds = [];
            } else {
                state.miniViewIds?.unshift(action.payload)
            }
        }
    },
});

export const {
    useropen,
    seltypeorcategory,
    listsetting1,
    listsetting2,
    listsetting3,
    listsetting1_2,
    listsetting2_2,
    listsetting3_2,
    listsetting1_3,
    listsetting2_3,
    listsetting3_3,
    companylogourlset,
    gptcountset,
    setMiniViewIds
} = user.actions;

export default user.reducer;
